<template>
	<div class="record-main-div">
		<el-tabs v-model="activeName">
			<el-tab-pane :label="$t('vip.account.transactions.name')" name="first">
				<el-row>
					<el-form>
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
							<div style="float: left;margin-right: 10px;">
								<el-form-item>
									<el-date-picker v-model="expenditureDate" type="datetimerange" range-separator="至" style="width: 100%"
										:start-placeholder="$t('vip.account.transactions.start_time')" :end-placeholder="$t('vip.account.transactions.end_time')" :picker-options="pickerOptions"></el-date-picker>
								</el-form-item>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
							<div style="float: left;margin-left: 10px;margin-right: 10px">
								<el-form-item>
									<el-input :placeholder="$t('vip.account.transactions.transaction_id')" v-model="search.transactionStatement"></el-input>
								</el-form-item>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="8">
							<div style="float: right;margin-bottom: 22px">
								<el-button @click="loadData(null)" type="primary" icon="fa fa-search"></el-button>
							</div>
						</el-col>
					</el-form>
				</el-row>

				<div class="table-div" v-loading="loading">
					<el-table :data="expenditureData.list" style="width: 100%"
						header-cell-class-name="el-thead-20220712">
						<el-table-column prop="transactionStatement" :label="$t('vip.account.transactions.transaction_id')" width="200" align="center"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="createTime" :label="$t('vip.account.transactions.time')" width="170" align="center">
							<template slot-scope="scope">
								{{ $fomatTime(scope.row.createTime, 'yyyy-MM-DD HH:mm:ss') }}
								<!-- <br /> -->
								<!-- {{ $fomatTime(scope.row.createTime,'HH:mm:ss') }} -->
							</template>
						</el-table-column>

						<el-table-column prop="revenueAndExpenditureType" :label="$t('vip.account.transactions.transaction_type.name')" width="120" align="center">
							<template slot="header" slot-scope="scope">
								<el-popover placement="bottom-start" trigger="click" popper-class="popover-filter-202207130356">
									<div>
										<el-checkbox-group v-model="search.InOfOut">
											<div v-for="item in inOrOutTypes" :key="item.type" class="check-box-div">
												<el-checkbox :label="item.type">
													{{ item.cn }}
												</el-checkbox>
											</div>
										</el-checkbox-group>
									</div>
									<span slot="reference">
										{{$t('vip.account.transactions.transaction_type.name')}}
										<i class="fa fa-filter" aria-hidden="true"></i>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								{{ getTransactionTypeNameByType(scope.row.revenueAndExpenditureType) }}
							</template>
						</el-table-column>

						<el-table-column prop="transactionType" :label="$t('vip.account.transactions.biz_type.name')" min-width="100" align="center" show-overflow-tooltip>
							<template slot="header" slot-scope="scope">
								<el-popover placement="bottom-start" trigger="click" popper-class="popover-filter-202207130356">
									<div>
										<el-checkbox-group v-model="search.transactionTypes">
											<div v-for="item in bizTypes" :key="item.type" class="check-box-div">
												<el-checkbox :label="item.type">
													{{ item.cname }}
												</el-checkbox>
											</div>
										</el-checkbox-group>
									</div>
									<span slot="reference">
										{{$t('vip.account.transactions.biz_type.name')}}
										<i class="fa fa-filter" aria-hidden="true"></i>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								{{ getBizTypeNameByType(scope.row.transactionType) }}
							</template>
						</el-table-column>

						<el-table-column prop="channelBusiness" :label="$t('vip.account.transactions.biz_channel.name')" width="100" align="center">
							<template slot="header" slot-scope="scope">
								<el-popover placement="bottom-start" trigger="click" popper-class="popover-filter-202207130356">
									<div>
										<el-checkbox-group v-model="search.channelBusiness">
											<div v-for="item in biz_channels" :key="item.type" class="check-box-div">
												<el-checkbox :label="item.type">
													{{ item.cn }}
												</el-checkbox>
											</div>
										</el-checkbox-group>
									</div>
									<span slot="reference">
										{{$t('vip.account.transactions.biz_channel.name')}}
										<i class="fa fa-filter" aria-hidden="true"></i>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								{{ getBizChannelNameByType(scope.row.channelBusiness) }}
							</template>
						</el-table-column>

						<el-table-column prop="channelBusiness" :label="$t('vip.account.transactions.biz_id')" width="130" align="left" header-align="center"
							show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.channelStatementCode">
									{{ scope.row.channelStatementCode }}
								</span>
								<span v-else> -- </span>
							</template>
						</el-table-column>

						<el-table-column prop="num" :label="$t('vip.account.transactions.amount')" align="center" width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.revenueAndExpenditureType == 'in'" style="color: #67C23A; ">
									+{{ scope.row.num }}
								</span>
								<span v-else style="color: #F56C6C; ">
									-{{ Math.abs(scope.row.num) }}
								</span>
							</template>
						</el-table-column>

						<el-table-column prop="num" :label="$t('vip.account.transactions.balance')" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.balance }}
							</template>
						</el-table-column>

						<el-table-column prop="functionType" :label="$t('vip.account.transactions.function_type.name')" min-width="80" fixed="right" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ getFunctionTypeNameByType(scope.row.functionType) }}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page-div">
					<el-pagination background
						layout="prev, pager, next"
						:current-page="search.page"
						:page-size="search.pageSize"
						@current-change="pageChange"
						:total="expenditureData.total"
						hide-on-single-page>
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import { api_accountStatement_list } from '@/components/api/accountStatement.js'
import { dateAdd } from "@/components/common/utils/time";

export default {
	name: 'tradingRecordPage',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER'],
	data() {
		return {
			loginUser: this.LOGINUSER,
			activeName: 'first',
			search: {
				page: 1,
				pageSize: 10,
				transactionStatement : null,
				InOfOut: [],
				transactionTypes : [],
				channelBusiness : []
			},
			loading: false,
			pickerOptions: {
				shortcuts: [{
					text: this.$t("app.dateTime.picker.options.last_week"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t("app.dateTime.picker.options.last_month"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t("app.dateTime.picker.options.last_three_months"),
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
			expenditureDate: ['',''],
			expenditureData: {}
		}
	},
	created() {
		this.$options.methods.loadData(this)
	},
	computed: {
		inOrOutTypes() {
			return [
				{ value : 1, type : 'in', cn : this.$t("vip.account.transactions.transaction_type.credit")},
				{ value : 2, type : 'out', cn : this.$t("vip.account.transactions.transaction_type.debit")},
			]
		},
		bizTypes()  {
			return [
				{ value: 1, type: 'recharge', key: 'CZ', cname: this.$t("vip.account.transactions.biz_type.recharge") },
				// { value: 2 ,type : 'refund' , key : 'TK' , cname : this.$t("vip.account.transactions.transaction_type.refund") },
				{ value: 3, type: 'withdrawal', key: 'TX', cname: this.$t("vip.account.transactions.biz_type.withdraw") },
				{ value: 4, type: 'consumption', key: 'XF', cname: this.$t("vip.account.transactions.biz_type.consume") },
				{ value: 5, type: 'eventGift', key: 'zs', cname: this.$t("vip.account.transactions.biz_type.gift.activity") },
				{ value: 6, type: 'systemGift', key: 'zs', cname: this.$t("vip.account.transactions.biz_type.gift.system") },
			]
		},
		biz_channels() {
		 	return [
				{ value : 1, type : 'Balance', cn : this.$t("vip.account.transactions.biz_channel.balance")},
				{ value : 2, type : 'Paypal', cn : this.$t("vip.account.transactions.biz_channel.paypal")},
				{ value : 3, type : 'alipay', cn : this.$t("vip.account.transactions.biz_channel.alipay")},
				{ value : 4, type : 'wechatPay', cn : this.$t("vip.account.transactions.biz_channel.wechat")},
			]
		},
		function_types() {
			return [
				{ type : 'signInToEarnPoints', cn : this.$t("vip.account.transactions.function_type.sign_in")},
				{ type : 'keywordMonitorCreation', cn : this.$t("vip.account.transactions.function_type.kw.monitor.name") + '-' + this.$t("vip.account.transactions.function_type.kw.monitor.create")},
				{ type : 'keywordMonitoringRenewal', cn : this.$t("vip.account.transactions.function_type.kw.monitor.name") + '-' + this.$t("vip.account.transactions.function_type.kw.monitor.renew")},
				{ type : 'reverseSearchTrafficWord', cn : this.$t("vip.account.transactions.function_type.kw.reverse_lookup")},
				{ type : 'pointsRecharge', cn : this.$t("vip.account.transactions.function_type.recharge")},
				{ type: 'weeklyKeywordHistoryDate',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.unlock")},
				{ type: 'weeklyKeywordHotBazaar',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.hot_market")},
				{ type: 'weeklyKeywordGrowthBazaar',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.growth_market")},
				{ type: 'weeklyKeywordSoaringBazaar',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.soaring_market")},
				{ type: 'weeklyKeywordPotentialBazaar',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.potential_market")},
				{ type: 'weeklyKeywordNicheBazaar',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.niche_market")},
				{ type: 'weeklyKeywordTrend',cn: this.$t("vip.account.transactions.function_type.aba.name") + '-' + this.$t("vip.account.transactions.function_type.aba.trend_analysis")},
				{ type: 'initialGiftByRegister',cn: this.$t("vip.account.transactions.function_type.register.name") + '-' + this.$t("vip.account.transactions.function_type.register.gift")},
				{ type: 'keywordAnalysis', cn : this.$t("vip.account.transactions.function_type.kw.analysis")},
				{ type: 'keywordMonitor2Creation', cn : this.$t("vip.account.transactions.function_type.kw.monitor_v2.name") + '-' + this.$t("vip.account.transactions.function_type.kw.monitor_v2.create")},
				{ type: 'keywordMonitoring2Renewal', cn : this.$t("vip.account.transactions.function_type.kw.monitor_v2.name") + '-' + this.$t("vip.account.transactions.function_type.kw.monitor_v2.renew")},
			]
		}
	},
	components: {},
	methods: {
		pageChange : function(val) {
			this.$data.search.page = val
			this.$options.methods.loadData(this)
		},
		loadData: function(this_) {
			this_ = this_ || this
			let obj = JSON.parse(JSON.stringify(this_.$data.search))
			if (this_.$data.expenditureDate){
				obj.startTime = this_.$data.expenditureDate[0]
				obj.endTime = this_.$data.expenditureDate[1]
			}
			if (obj.transactionTypes && obj.transactionTypes.length > 0){
				obj.transactionTypes = encodeURI(obj.transactionTypes)
			}
			if (obj.InOfOut && obj.InOfOut.length > 0){
				obj.InOfOut = encodeURI(obj.InOfOut)
			}
			if (obj.channelBusiness && obj.channelBusiness.length > 0){
				obj.channelBusiness = encodeURI(obj.channelBusiness)
			}
			// 开启遮罩
			this_.$data.loading = true
			api_accountStatement_list(obj).then(res => {
				this_.$data.expenditureData = res.data
				// 关闭遮罩
				this_.$data.loading = false
			}).catch(err => {
				//关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})
		},
		getFunctionTypeNameByType: function(v) {
			return this.function_types.find(i => i.type == v).cn
		},
		getTransactionTypeNameByType: function(v) {
			return this.inOrOutTypes.find(i => i.type == v).cn
		},
		getBizTypeNameByType: function(v) {
			return this.bizTypes.find(i => i.type == v).cname
		},
		getBizChannelNameByType: function(v) {
			return this.biz_channels.find(i => i.type == v).cn
		}
	},
	watch: {}
}
</script>

<style scoped>
.record-main-div {
	padding: 10px;
}

.page-div {
	padding: 20px 0px;
	text-align: center;
}
.check-box-div{
	padding: 5px 0;
}
</style>
<style>
.popover-filter-202207130356{
	min-width:unset;
}
.el-thead-20220712 {
	font-size: 14px;
	color: #6d757a;
	background-color: #f4f5f7 !important;
}
</style>
